import { BaseApi } from './base.api.js';

export class BigdesRoadMapWorkPackageApi extends BaseApi {
    constructor(client) {
        super(client, '/bigdes-road-map-work-packages');
    }
}
